<template>
    <div class="full-group" ref="fullGroup" style="overflow: auto;">
        <el-carousel direction="vertical" :autoplay="false" :loop="false" ref="carouselFull" @change="rollNumFn"
                     :class="addClass === 1 ? 'blue-class' : ''">
            <el-carousel-item :key="1">
                <div class="full-item" :key="1">
                    <HeaderMei></HeaderMei>
                    <div style="flex: 1; position: relative;">
                        <div
                            style="position: absolute; width: 100%; height: 160px; top: 50%; margin-top: -70px; text-align: center;">
                            <img src="../assets/images/text.png"/>
                        </div>
                        <div style="position: absolute;bottom: 20px;left: 50%;cursor: pointer" v-show="!isshow"
                             @click="clickfun()">
                            <img src="../assets/images/05.png"/>
                        </div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item :key="2">
                <div class="full-item" style="padding: 0 17px 0 0;"
                     :style="{'visibility': isshow ? 'visible' : 'hidden'}">
                    <!--<div style="position: absolute;top: 10px;left: 50%;">-->
                    <!--<img src="../assets/images/06.png" class="className"/><br>-->
                    <!--<div style="color: #fff;position: absolute;left: -17px;width: 100px">向上滑动</div>-->
                    <!--</div>-->
                    <div style="flex: 1; color: #ffffff;margin-top: 20px">
                        <div class="line"></div>
                        <div style="margin: 10px 0;">
                            <div style="font-size: 28px; font-weight: bold;">重庆美天科技有限公司</div>
                            <div style="font-size: 14px;">Chongqing Meitian Technology <span
                                style="text-decoration: underline;">Co.,Ltd</span></div>
                        </div>
                        <div style="margin: 10px 0; font-size: 14px;">
                            <div style="height: 20px;line-height: 20px;">重庆美天科技是一家以气象服务为基础的科技公司</div>
                            <div style="height: 20px;line-height: 20px;">通过互联网高新科技技术实现专业气象服务与公共气象服务数字化升级</div>
                            <div style="height: 20px;line-height: 20px;">我们的使命是 "为用户提供精准、高效的气象信息服务"</div>
                        </div>
                        <div class="text-item">
                            <div class="item-title">业务范围</div>
                            <div class="item-content">重庆美天科技有限公司是一家专注于气象服务的科技有限公司, 公司业务范围涵盖30余种产品及项目, 地域涉及全国15省80余地市
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="item-title">人员组成</div>
                            <div class="item-content">目前公司员工70余人, 其中博士1人、硕士8人、本科65人( 其中: 气象类专业硕士5人 )</div>
                        </div>
                        <div class="text-item">
                            <div class="item-title">行业专注</div>
                            <div class="item-content">通过在气象领域长达9年的深耕, 已拥有完成的气象研究、产品研发、系统开发团队</div>
                        </div>
                        <div class="text-item">
                            <div class="item-title">愿景与使命</div>
                            <div class="item-content">专注特色气象, 为客户提供精准、高效的气象信息服务, 为社会创造财富, 为客户和用户创造价值</div>
                        </div>
                        <div class="line"></div>
                        <div style="margin: 10px 0;">
                            <div style="font-size: 24px; font-weight: bold;">发展历程</div>
                            <div style="font-size: 14px;">development history</div>
                        </div>
                        <div style="margin: 10px 0;">
                            <div class="step" style="display: flex; width: 585px;">
                                <div class="first">现在</div>
                                <div class="center">2018</div>
                                <div class="center">2016</div>
                                <div class="center">2014</div>
                                <div class="last">2012</div>
                            </div>
                            <div style="display: flex;">
                                <div class="circular" :class="{'select': nowCyear==='现在'}"
                                     @mouseenter="nowCyearChange('现在')"></div>
                                <div class="horizontal-line-container">
                                    <div class="horizontal-line"></div>
                                </div>
                                <div class="circular" :class="{'select': nowCyear==='2018'}"
                                     @mouseenter="nowCyearChange('2018')"></div>
                                <div class="horizontal-line-container">
                                    <div class="horizontal-line"></div>
                                </div>
                                <div class="circular" :class="{'select': nowCyear==='2016'}"
                                     @mouseenter="nowCyearChange('2016')"></div>
                                <div class="horizontal-line-container">
                                    <div class="horizontal-line"></div>
                                </div>
                                <div class="circular" :class="{'select': nowCyear==='2014'}"
                                     @mouseenter="nowCyearChange('2014')"></div>
                                <div class="horizontal-line-container">
                                    <div class="horizontal-line"></div>
                                </div>
                                <div class="circular" :class="{'select': nowCyear==='2012'}"
                                     @mouseenter="nowCyearChange('2012')"></div>
                            </div>
                        </div>
                        <div style="width: 1349px;overflow: hidden;position: relative;height: 120px">
                            <div class="clearfix" id="step-intro-box" :style="{'left':left+'px','width':width + 'px'}">
                                <div class="step-intro" ref="ele">
                                    <div class="intro-year">2020</div>
                                    <div class="intro-text">美天科技有限公司将继续坚持秉承专业精神，继续深耕，开拓思维，提升气象服务价值，为气象领域带来更优质、专业的气象服务。
                                    </div>
                                </div>
                                <div class="step-intro">
                                    <div class="intro-year">2019</div>
                                    <div class="intro-text">
                                        1月 确立气象一体化平台战略<br>
                                        3月 响应国家号召参与建设全国多省“六个一”基层防灾平台
                                    </div>
                                </div>
                                <div class="step-intro">
                                    <div class="intro-year">2018</div>
                                    <div class="intro-text">
                                        4月 设立气象研究部门，邀请多个行业专家担任公司技术顾问
                                    </div>
                                </div>
                                <div class="step-intro">
                                    <div class="intro-year">2017</div>
                                    <div class="intro-text">
                                        2月 推出服务于全国用户的气象类手机应用：“美天气”APP
                                    </div>
                                </div>
                                <div class="step-intro">
                                    <div class="intro-year">2016</div>
                                    <div class="intro-text">
                                        5月 与全国五家高校开展战略合作，共同致力于专业气象人才培养
                                    </div>
                                </div>
                                <div class="step-intro">
                                    <div class="intro-year">2014</div>
                                    <div class="intro-text">
                                        4月 重庆美天科技有限公司正式成立
                                    </div>
                                </div>
                                <div class="step-intro">
                                    <div class="intro-year">2013</div>
                                    <div class="intro-text">
                                        7月 成功研发出重庆人工影响天气一体化系统
                                    </div>
                                </div>
                                <div class="step-intro">
                                    <div class="intro-year">2012</div>
                                    <div class="intro-text">
                                        1月 初创团队确立互联网+气象理念方向
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <FooterMei></FooterMei>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import HeaderMei from '@/components/headerMei';
import FooterMei from '@/components/footerMei';

export default {
    name: "introduce",
    components: { HeaderMei, FooterMei },
    data() {
        return {
            addClass: 1,
            reverse: true,
            activities: [{
                content: '活动按期开始',
                timestamp: '2018-04-15'
            }, {
                content: '通过审核',
                timestamp: '2018-04-13'
            }, {
                content: '创建成功',
                timestamp: '2018-04-11'
            }],
            isshow: false,
            nowCyear: '现在',
            width: 'width: 100%',
            left: 0
        }
    },
    mounted() {
        this.eventListenerHandle('addEventListener');
        this.$nextTick(() => {
            this.width = (1349 / 4 * 8);
            console.log(this.$el.querySelector('.step-intro').offsetWidth);
        });
    },
    beforeDestroy() {
        this.eventListenerHandle('removeEventListener');
    },
    methods: {
        rollNumFn(val) {
            if (val === 1 || val === 3 || val === 5) this.addClass = 1;
            else this.addClass = 0
        },
        clickfun() {
            this.isshow = true;
            this.$refs.carouselFull.next();
        },
        deferred(fn, wait) {
            let timeout
            return function () {
                const context = this
                const args = arguments
                if (timeout) clearTimeout(timeout)
                timeout = setTimeout(() => {
                    fn.apply(context, args)
                }, wait)
            }
        },
        handleScroll(e) {
            let detail = e.deltaY || e.detail;
            if (detail > 0) {
                this.isshow = true;
                this.$refs.carouselFull.next();
            } else {
                setTimeout(() => {
                    this.isshow = false;
                }, 300)
                this.$refs.carouselFull.prev();
            }
        },
        handleKeyup(e) {
            if (e.keyCode === 38) {
                setTimeout(() => {
                    this.isshow = false;
                }, 300)
                this.$refs.carouselFull.prev()
            } else if (e.keyCode === 40) {
                this.$refs.carouselFull.next()
                this.isshow = true;
            }
        },
        eventListenerHandle(sign) {
            const dom = this.$refs.fullGroup;
            dom[sign]('mousewheel', this.deferred(this.handleScroll, 300), true) ||
            dom[sign]('DOMMouseScroll', this.deferred(this.handleScroll, 300), false);
            window[sign]('keyup', this.handleKeyup)
        },
        nowCyearChange(val) {
            this.nowCyear = val;
            let m = 1349 / 4;
            switch (val) {
                case '现在':
                    this.left = 0;
                    break;
                case '2018':
                    this.left = -m * 2;
                    break;
                case '2016':
                    this.left = -m * 4;
                    break;
                case '2014':
                    this.left = -m * 5;
                    break;
                case '2012':
                    this.left = -m * 7;
                    break;
                default:
                    break;
            }
        }
    },
}
</script>

<style scoped lang="less">
    .full-group {
        width: 100%;
        height: 100%;
        /deep/ .el-carousel--vertical {
            height: 100%;
            .el-carousel__container {
                height: 100%;
            }
        }
        .full-item {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            .line {
                width: 120px;
                height: 30px;
                border-bottom: solid 2px #ffffff87;
            }
            .text-item {
                margin: 15px 0;
                .item-title {
                    height: 40px;
                    line-height: 40px;
                    font-weight: bold;
                    font-size: 24px;

                }
                .item-content {
                    font-size: 14px;
                    height: 20px;
                    line-height: 20px;
                }
            }
            .step {
                display: flex;
                width: 600px;
                height: 40px;
                .first {
                    flex: 1;
                    text-align: left;
                    line-height: 40px;
                }
                .center {
                    flex: 2;
                    text-align: center;
                    line-height: 40px;
                }
                .last {
                    flex: 1;
                    text-align: right;
                    line-height: 40px;
                }
            }
            .circular {
                width: 17px;
                height: 17px;
                border-radius: 50%;
                background-color: #9AA2A6;
                cursor: pointer;
                &.select {
                    background-color: #ffffff;
                }
            }
            .horizontal-line-container {
                width: 125px;
                height: 17px;
                padding: 8px 0;
                box-sizing: border-box;
                .horizontal-line {
                    width: 100%;
                    height: 1px;
                    background-color: #ffffff87;
                }
            }
            .step-intro {
                width: 297.25px;
                float: left;
                padding-right: 40px;
                .intro-year {
                    height: 30px;
                    line-height: 30px;
                    border-bottom: solid 1px #ffffff87;
                    text-align: left;
                    font-size: 20px;
                }
                .intro-text {
                    font-size: 14px;
                }
            }
            #step-intro-box {
                position: absolute;
                top: 0;
                left: 0;
                transition: all 0.5s;
            }
        }
    }

    .className {
        -webkit-animation: twinkling 1s infinite ease-in-out
    }

    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both
    }

    @-webkit-keyframes twinkling {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes twinkling {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/introduce.vue